<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconjigou1"></i>
      班级数据
    </div>
    <div class="padding-sm">
      <div class="flex align-start">
        <div class="class-list-box">
          <h3>班级列表({{roomList.length}})</h3>
          <ul class="class-list">
            <li :class="{'active':item.class_id === roomId}" v-for="item in roomList" :key="item.class_id" @click="roomId = item.class_id">{{ item.class_name }}({{item.stu_num}})</li>
          </ul>
        </div>
        <div class="student-list-box">
          <h3>学生列表({{studentList.length}})</h3>
          <div class="flex align-center justify-between">
            <el-input v-model="stu_name" placeholder="请输入学生姓名"></el-input>
            <el-button type="primary" @click="getStuList">
              搜索
            </el-button>
          </div>
          <ul class="student-list">
            <li :class="{'active':item.stu_id === stuId}" v-for="item in studentList" :key="item.stu_name" @click="stuId = item.stu_id">{{ item.stu_name }}</li>

          </ul>
        </div>
        <div class="flex-sub student-info">
          <div class="volunteer-detail" v-if="stu">
            <div class="border-bottom padding-sm">
              <span class="name">{{ stu.stu_name }}</span>
              <span class=" padding-left font-size-lg">{{ stu.stu_sex===1?'男':'女' }}</span>
              <span class=" padding-left font-size-lg">{{ stu.stu_age }}</span>
              <span class=" padding-left font-size-lg">{{ stu.class_name }}</span>
              <span class=" padding-left font-size-lg">{{ stu.school }}</span>
            </div>
            <div class="border-bottom padding-sm">
              <h2>学习课程:</h2>
              <div>
                <span class="margin-right" v-for="(item,index) in stu.classes" :key="index">{{item}}</span>
              </div>
            </div>
            <div class="border-bottom padding-sm"  >
              <h2 class="flex align-center justify-between">老师评语:

              </h2>
              <div v-for="(item,index) in stu.resumes" :key="index" class="margin-bottom-sm">
                <p>
                  {{item.content}}
                </p>
                <p class="flex justify-end" style="color: #999;">
                  日期：{{ item.add_time }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {xieClassList, xieSchoolStuList} from "@/api/coordinate";
import {studentResume} from "@/api/fuse";

export default {
  name: "volunteer",
  data() {
    return {
      roomList:[],
      roomId:'',
      stu_name:'',
      studentList:[],
      stuId:'',
      stu:null,
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/coordinate/organ5',
        "当前位置：机构数据 > 班级数据",
        true
    );
    this.getList()
  },
  methods: {
    async getList(){
      let _list = await xieClassList(1,1000,this.$route.query.id)
      this.roomList = _list.data.list
      if(this.roomList.length>0) {
        this.roomId = this.roomList[0].class_id
      }else{
        this.roomId = ''
      }
    },

    async getStuList(){
      let _list = await xieSchoolStuList(1,1000,this.$route.query.id,this.roomId ,this.stu_name)
      this.studentList = _list.data.list
      if(this.studentList.length>0){
        this.stuId = this.studentList[0].stu_id
      }else{
        this.stuId = ''
        this.stu = null
      }

    },
    async getStuDetail(){
      let _info = await studentResume(this.stuId)
      this.stu = _info.data
    },

  },
  watch:{
    roomId(){
      if(this.roomId) this.getStuList()
    },
    stuId(){
      if(this.stuId) this.getStuDetail()
    }
  }
}
</script>

<style scoped lang="scss">
.content-warpper{
  .class-list-box{
    width: 300px;
    min-height: 400px;
    padding: 10px 20px;
    margin-right: 20px;
    border: 1px solid #e5e5e5;
    h3{
      font-size: 18px;
      line-height: 20px;
      font-weight: bold;
      margin: 10px 0 20px;
      padding-left: 10px;
      border-left: 3px solid #009688;
    }
    .class-list{
      li{
        line-height: 36px;
        cursor: pointer;
        background-color: #f1f1f1;
        border-radius: 4px;
        margin-bottom: 5px;
        padding: 0 10px;
        &.active{
          background:#009688 ;
          color: #fff;
        }
      }
    }
  }
  .student-list-box{
    width: 300px;
    min-height: 400px;
    padding: 10px 20px;
    margin-right: 20px;
    border: 1px solid #e5e5e5;
    h3{
      font-size: 18px;
      line-height: 20px;
      font-weight: bold;
      margin: 10px 0 20px;
      padding-left: 10px;
      border-left: 3px solid #009688;
    }
    .student-list{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 10px;
      li{
        width: 45%;
        line-height: 36px;
        cursor: pointer;
        background-color: #f1f1f1;
        border-radius: 4px;
        margin-bottom: 5px;
        padding: 0 10px;
        &.active{
          background:#009688 ;
          color: #fff;
        }
      }
    }
  }
  .volunteer-detail {
    border: 1px dashed #999;

    .border-bottom {
      border-bottom: 1px dashed #999;
      .name{
        font-size: 28px;
        font-weight: bold;
        color: #009688;
      }
      h2 {
        font-size: 18px;
        line-height: 42px;
        color: #009688;
        p{
          font-size: 14px;
          color: #666;
          line-height: 30px;
          text-align: right;
          font-weight: normal;
        }
      }
      div{
        line-height: 200%;
        font-size: 16px;

        p{
          text-indent: 32px;
          &.hals-color{
            color: #009688;
            text-indent:0;
          }
        }
      }
    }
  }

}
</style>